import PropTypes from 'prop-types';

import Text from '@zenbusiness/zui/Text';

function SectionNumber({ number, isValid }) {
  const status = isValid ? 'valid' : 'invalid';

  const iconStyles = {
    invalid: {
      backgroundColor: 'common.black',
      color: 'text.white'
    },
    valid: {
      backgroundColor: 'background.green.light',
      color: 'text.primary'
    }
  };

  return (
    <Text
      sx={(theme) => ({
        borderRadius: theme.shape.rounded.full,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 28,
        width: 28,
        ...iconStyles[status]
      })}
      weight="medium"
    >
      {number}
    </Text>
  );
}

SectionNumber.propTypes = {
  isValid: PropTypes.bool.isRequired,
  number: PropTypes.number.isRequired
};

export default SectionNumber;
